import React from 'react';
import logo from './logo.svg';
import './App.css';
import Main from './views/Main/Main';

function App() {
  return (
    <Main />
  );
}

export default App;
